import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();

  // Replace this with your real domain
  const baseUrl = "https://forfunlab.com";

  // Map of routes to breadcrumb labels
  const breadcrumbMap = {
    "/": "Home",
    "/lab-ninjas": "Lab Ninjas",
    "/football-predictor": "Football Predictor"
  };

  const path = location.pathname;
  const crumbs = [];

  // Always include home
  crumbs.push({
    "@type": "ListItem",
    position: 1,
    name: breadcrumbMap["/"],
    item: `${baseUrl}/`
  });

  // If not home, include current route
  if (path !== "/" && breadcrumbMap[path]) {
    crumbs.push({
      "@type": "ListItem",
      position: 2,
      name: breadcrumbMap[path],
      item: `${baseUrl}${path}`
    });
  }

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs
  };

    // Organization schema with alternateName
    const organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "ForFunLab",
        alternateName: "For Fun Lab",
        url: "https://forfunlab.com",
        logo: "https://forfunlab.com/logo512.png",
      };

  return (
    <Helmet>
        <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
        </script>
        <script type="application/ld+json">
            {JSON.stringify(organizationSchema)}
        </script>
    </Helmet>
  );
};

export default Breadcrumbs;
